// Centralized color constants for the application
// Based on Apple design system used throughout the app

export const COLORS = {
    // Primary colors
    PRIMARY: '#1D1D1F',
    SECONDARY: '#86868B',

    // Status colors
    UP: '#34C759',
    DOWN: '#FF3B30',

    // Accent colors
    ACCENT: '#007AFF',
    PURPLE: '#5856D6',
    ORANGE: '#FF9F0A',

    // Background
    BACKGROUND: '#F5F5F7',
    CARD_BG: 'rgba(255, 255, 255, 0.7)',

    // Border
    BORDER: 'rgba(255, 255, 255, 0.5)',
    DIVIDER: 'rgba(0, 0, 0, 0.06)',
};

// Sentiment-based background and text colors
export const SENTIMENT_COLORS = {
    positive: { background: 'rgba(52,199,89,0.12)', color: '#34C759' },
    negative: { background: 'rgba(255,59,48,0.12)', color: '#FF3B30' },
    neutral: { background: 'rgba(134,134,139,0.12)', color: '#86868B' },
    bullish: { background: 'rgba(52,199,89,0.10)', color: '#34C759' },
    bearish: { background: 'rgba(255,59,48,0.10)', color: '#FF3B30' },
};

// Impact level colors
export const IMPACT_COLORS = {
    high: { background: 'rgba(255,59,48,0.10)', color: '#FF3B30' },
    medium: { background: 'rgba(255,159,10,0.10)', color: '#FF9F0A' },
    low: { background: 'rgba(134,134,139,0.10)', color: '#86868B' },
};

// Brand colors for AI companies
export const BRAND_COLORS = {
    openai: '#10A37F',
    anthropic: '#D97757',
    google: '#4285F4',
    meta: '#A855F7',
    deepseek: '#06B6D4',
    xai: '#1D1D1F',
    policy: '#FF3B30',
    future: '#86868B',
};

// Article style colors
export const STYLE_COLORS = {
    zhihu: { bg: 'rgba(0,102,204,0.08)', color: '#0066CC', label: 'Zhihu' },
    industry: { bg: 'rgba(52,199,89,0.08)', color: '#34C759', label: 'Industry' },
    debate: { bg: 'rgba(255,59,48,0.08)', color: '#FF3B30', label: 'Debate' },
    thesis: { bg: 'rgba(88,86,214,0.08)', color: '#5856D6', label: 'Thesis' },
    viral: { bg: 'rgba(255,159,10,0.08)', color: '#FF9F0A', label: 'Viral' },
    professional: { bg: 'rgba(0,122,255,0.08)', color: '#007AFF', label: 'Pro' },
    casual: { bg: 'rgba(175,82,222,0.08)', color: '#AF52DE', label: 'Casual' },
    short: { bg: 'rgba(90,200,250,0.08)', color: '#5AC8FA', label: 'Short' },
};

export default COLORS;
